<template>
  <v-dialog
    v-model="model"
    transition="dialog-bottom-transition"
    :max-width="maxWidth"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
      >Экспорт данных</v-toolbar>
      <v-card-text class="mt-5">
        <v-row>
          <v-textarea
            label="Экспорт данных"
            v-model="exportString"
            ref="textToCopy"
            readonly
          >
            <template v-slot:prepend>
              <v-icon>{{ mdiExport }}</v-icon>
            </template>
          </v-textarea>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          color="primary"
          @click="copyToClipboard"
        >
          <v-icon :color="isCopyPressed ? 'light-green' : 'default'">{{ mdiCheck }}</v-icon>
          Копировать
        </v-btn>

        <v-btn
          color="green darken-1"
          text
          @click.native="$emit('close')"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mdiExport,
  mdiCheck
} from '@mdi/js'

import config from '@/app/config'
import idb from '@/app/idb'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      exportString: '',
      mdiExport,
      mdiCheck,
      isCopyPressed: false
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    maxWidth () {
      return config.maxWidth
    }
  },
  mounted () {
    Promise.all([
      idb.getAll(idb.PROFILES),
      idb.getAll(idb.MEASURES)
    ]).then(values => {
      this.exportString = JSON.stringify({
        [idb.PROFILES]: values[0],
        [idb.MEASURES]: values[1]
      })
    })
  },
  methods: {
    copyToClipboard () {
      let textToCopy = this.$refs.textToCopy.$el.querySelector('textarea')
      textToCopy.select()
      document.execCommand('copy')
      this.isCopyPressed = true
    }
  }
}
</script>
